import React, { useEffect, useState } from 'react';
import { Outlet} from 'react-router-dom'
import { deleteTemplate, fetchTemplateData, updateTemplate } from '../../../service/template';
import CustomToast from '../../Toast';


const Templates = () => {
    const [template, setTemplate] = useState({});
    const [templateList, setTemplateList] = useState([])
    const [search, setSearch] = useState('')


    useEffect(() => {
        getCourses()
    }, [])

    const getCourses = async () => {
        try {
            const course = await fetchTemplateData(search);
            if (course.status) {
                setTemplate(course.data);
                setTemplateList(course?.data?.list);
            } else {
                console.error("Error fetching courses:", course.error);
                CustomToast.error('Error while fetching courses')
            }
        } catch (error) {
            console.error("An unexpected error occurred:", error);
            CustomToast.error('Error while fetching courses')
        }
    };

    function handleSearch(e) {
        const value = e.target.value;
        if (value) {
            const filteredOptions = templateList?.filter(option =>
                option?.title?.toLowerCase().includes(value.toLowerCase())
            );
            setTemplateList(filteredOptions);
        } else {
            getCourses();
        }
    }

    const handleDelete = async (id) => {
        try {
            const response = await deleteTemplate(id);
            // Reload the template list after successful deletion
            getCourses();
        } catch (error) {
            console.error("Error deleting template:", error);
            CustomToast.error("Failed to delete template");
        }
    };

    const dateFormat = (date) =>
        new Date(date).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });

    // Dynamic CSS class for compliance module badges
    const getComplianceClass = (name) => {
        if (!name) return "";
        const n = name.toLowerCase();
        if (n.includes("policy")) return "text-black badge-posh";
        if (n.includes("poster")) return "text-black badge-visibility";
        if (n.includes("ic template")) return "text-black badge-internal";
        if (n.includes("email campaign")) return "text-black badge-training";
        if (n.includes("annual report")) return "text-black badge-documentation";
        if (n.includes("filing")) return "text-black badge-filing";
        return "";
    };

    return (
        <div className='page__main'>
            <div className="dashboard">
                <h4 className="mb-2">Templates</h4>
                <div className='row mb-4'>
                    <div className='col-md-4'>
                        <div className="card-box">
                            <p className='mb-0 d-flex'>
                                <div className='course_count'>{template.totalCount || 0}</div>
                                <div className="right-border"></div>
                                <div className='courses_create'>Templates Created</div>
                            </p>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className="card-box">
                            <p className='mb-0 d-flex'>
                                <div className='course_count'>{template.publishedCount || 0}</div>
                                <div className="right-border"></div>
                                <div className='courses_create'>Templates Published</div>
                            </p>
                        </div>
                    </div>
                    <div className='col-md-4 text-end'>
                        <a href="/create_template" className='btn btn-primary w-75'>Add Template</a>
                    </div>
                </div>
                <div className="card">
                    <div className="card-body">

                        <div className="d-flex justify-content-between align-items-center">
                            <div className='row g-3'>
                                <div className="col-auto">
                                    <label for="inputPassword6" className="col-form-label"><b>Templates</b></label>
                                </div>
                                <div className="col-auto">
                                    <div className="form-group has-search">
                                        <span className="form-control-feedback"><img src="/images/search.png" /></span>
                                        <input type="text" onChange={handleSearch} className="form-control" placeholder="Search Template" />
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex justify-content-between align-items-center mb-0">
                                <p className="d-flex justify-content-between align-items-center mb-0 mr-10"><span className='circle-status green'></span> Published</p>
                                <p className="d-flex justify-content-between align-items-center mb-0 mr-10"><span className='circle-status yellow'></span> Draft</p>
                            </div>
                        </div>
                    </div>
                </div>
                <table className="table border-table">
                    <thead className='thead-dark px-3'>
                        <tr>
                            <th className='col p-3'>Sr.No</th>
                            <th className='col p-3'>Title</th>
                            <th className='col p-3'>Role</th>
                            <th className='col p-3'>Compilance Module</th>
                            <th className='col p-3'>Format</th>
                            <th className='col p-3'>Published </th>
                            <th className='col p-3'>Status</th>
                            <th className='col p-3 text-center'>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {templateList?.map((item, index) => (
                            <tr key={index}>
                                <td align='center'>{index + 1}.</td>
                                <td>{item?.title || "-"}</td>
                                <td>
                                    <span className={`badge badge-role text-black text-capitalize ${item?.role === 'admin' ? 'badge-admin' : 'badge-ic'}`}>{item?.role || "-"}</span>
                                </td>
                                <td>
                                    <span
                                        className={`badge ${getComplianceClass(
                                            item?.category?.replace(/_/g, " ")
                                        )}`}
                                    >
                                        {item?.category
                                            ?.replace(/_/g, " ")
                                            ?.replace(/\b\w/g, (c) => c.toUpperCase()) || "-"}
                                    </span>
                                </td>
                                <td>
                                    {Array.isArray(item?.upload_url) && item.upload_url.length > 0
                                        ? item.upload_url.map((u, i) => (
                                            <span key={i} className="badge text-black text-capitalize badge-format me-1">
                                                {u.type}
                                            </span>
                                        ))
                                        : "-"}
                                </td>
                                <td>{item?.publish_date ? dateFormat(item.publish_date) : "-"}</td>
                               <td className="col px-3">
                                        {item?.status?.toLowerCase() === 'published' ? (
                                            <span style={{ color: '#4F9B94', fontWeight: 600 }}>
                                                <span style={{ fontSize: '1.2rem', marginRight: '5px' }}>●</span>
                                                Published
                                            </span>
                                        ) : (
                                            <span style={{ color: '#C4C4C4', fontWeight: 600 }}>
                                                <span style={{ fontSize: '1.2rem', marginRight: '5px' }}>✖</span>
                                                Draft
                                            </span>
                                        )}
                                    </td>
                                <td align='right' >
                                    <div className='d-flex flex-column'>
                                        <div key={item.course_id} className="dropdown organisations" style={{ cursor: "pointer" }}>
                                            <svg fill="#000000" xmlns="http://www.w3.org/2000/svg"
                                                width="30px" height="30px" viewBox="0 0 52 52" enable-background="new 0 0 52 52" >
                                                <path d="M20,44c0-3.3,2.7-6,6-6s6,2.7,6,6s-2.7,6-6,6S20,47.3,20,44z M20,26c0-3.3,2.7-6,6-6s6,2.7,6,6s-2.7,6-6,6 S20,29.3,20,26z M20,8c0-3.3,2.7-6,6-6s6,2.7,6,6s-2.7,6-6,6S20,11.3,20,8z" />
                                            </svg>
                                            <div className="dropdown-menu">
                                                <a style={{ cursor: "pointer" }} href={`/edit_template/${item?._id}`} className={`dropdown-item me-2`}>Edit</a>
                                                <a style={{ cursor: "pointer" }} onClick={() => handleDelete(item._id)} className={`dropdown-item`}>Delete</a>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>

                </table>
                {template && template.results?.length == 0 ? (<h3 style={{ paddingLeft: "40%", paddingTop: "10%" }}>No Data Found</h3>) : null}
            </div>
        </div>
    )
}

export default Templates;